import { useState, useCallback } from "react";

export function useSettings<T extends Record<string, unknown>>(
  key: string,
  defaults: T
): [T, (updates: Partial<T>) => void] {
  const [settings, setSettings] = useState<T>(() => {
    try {
      const raw = localStorage.getItem(key);
      if (raw) {
        return { ...defaults, ...JSON.parse(raw) };
      }
    } catch {
      // ignore
    }
    return defaults;
  });

  const updateSettings = useCallback(
    (updates: Partial<T>) => {
      setSettings((prev) => {
        const next = { ...prev, ...updates };
        localStorage.setItem(key, JSON.stringify(next));
        return next;
      });
    },
    [key]
  );

  return [settings, updateSettings];
}
